import { EpimsGenderDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadGender = createAction('[Gender] Load Gender');

export const loadGenderSuccess = createAction(
  '[Gender] Load Gender Success',
  props<{ gender: EpimsGenderDto[] }>()
);

export const loadGenderFailure = createAction(
  '[Gender] Load Gender Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addGender = createAction(
  '[Gender] Add Gender',
  props<{ newGender: EpimsGenderDto[] }>()
);

export const addGenderSuccess = createAction(
  '[Gender] Add Gender Success',
  props<{ newGender: EpimsGenderDto[] }>()
);

export const addGenderFailure = createAction(
  '[Gender] Add Gender Failure',
  props<{ error: any }>()
);

/**
 * Update Gender Collection Actions
 */
export const updateGender = createAction(
  '[Gender] Update Gender',
  props<{ updateGender: EpimsGenderDto[] }>()
);

export const updateGenderSuccess = createAction(
  '[Gender] Update Gender Success',
  props<{ updateGender: EpimsGenderDto[] }>()
);

export const updateGenderFailure = createAction(
  '[Gender] Update Gender Failure',
  props<{ error: any }>()
);

/**
 * Remove Gender Collection Actions
 */
export const removeGender = createAction(
  '[Gender] Remove Gender',
  props<{ ids: string[] }>()
);

export const removeGenderSuccess = createAction(
  '[Gender] Remove Gender Success',
  props<{ ids: string[] }>()
);

export const removeGenderFailure = createAction(
  '[Gender] Remove Gender Failure',
  props<{ error: any }>()
);
